/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%;width:100%}.application-container[_ngcontent-%COMP%]{width:100%;height:100vh;margin:0;padding:0;display:flex;align-items:center;justify-content:center}.fullscreen-container[_ngcontent-%COMP%]{position:fixed;left:0;top:0;width:100%!important;height:100%!important;z-index:1501;padding:.5rem}"];
export { styles as styles };
